import { objectFilterNullishValues } from 'shared/utils/objectFilterNullishValues';

type Args = {
  urlOrPath: string;
  base?: string;
  params?: any;
};

export const buildFullUrl = ({ urlOrPath, base, params }: Args) => {
  const [urlOrPathBase, urlOrPathParams = ''] = urlOrPath.split('?');

  let fullUrl = base || '';
  fullUrl += urlOrPathBase;

  const mergedParams = new URLSearchParams(urlOrPathParams);

  if (params) {
    const parsed =
      params instanceof URLSearchParams
        ? params
        : new URLSearchParams(objectFilterNullishValues(params));

    parsed.forEach((value, key) => {
      mergedParams.append(key, value);
    });
  }

  const paramsString = mergedParams.toString();

  if (paramsString) {
    fullUrl += `?${paramsString}`;
  }

  return fullUrl;
};
